import { BUCKET_NAME, BUCKET_REGION } from '../define/global';
import { v4 as uuidv4 } from 'uuid';
import * as AWS from 'aws-sdk';
import { pushFileByServer } from './InnerApi';

/* AWS.config.update({
  region: BUCKET_REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AWS_S3_POOLID
  })
}); */

const s3 = new AWS.S3({
  apiVersion: '2006-03-01',
  params: { Bucket: BUCKET_NAME }
});

export const pushFileDirect = (fileName, docFile) => {
  return new Promise((resolve, reject) => {
    try {
      const key = uuidv4();

      s3.putObject({ Key: key, Body: docFile.blob }, function (err, data) {
        if (err) {
          reject(err.message);
        }
        resolve({ key, su: true });
      });
    } catch (error) {
      reject(error.message);
    }
  });
};

export const pushFile = async (fileName, docFile) => {
  // return await pushFileDirect(fileName, docFile);
  return await pushFileByServer(fileName, docFile);
};

export const getFile = (key) => {
  return new Promise((resolve, reject) => {
    try {
      s3.getObject(
        {
          Key: key
        },
        (err, data) => {
          if (err) {
            reject(err.message);
          } else {
            //console.log(data.Body);
            resolve(data.Body);
          }
        }
      );
    } catch (err) {
      reject(err.message);
    }
  });
};

export const genS3DownloadLink = (shareID) => {
  return `https://${BUCKET_NAME}.s3.${BUCKET_REGION}.amazonaws.com/${shareID}`;
};
